export default "__VITE_ASSET__W3rs2UQZ__"